import styled from "styled-components";

interface Props {
	onClick: (e: any) => any;
	className?: string;
	children?: React.ReactNode;
}

export const EditLink: React.FC<Props> = ({ onClick, className, children }) => {
	return (
		<Styles className={className} onClick={(e) => onClick(e)}>
			{children || "Redigera"}
		</Styles>
	);
};

const Styles = styled.a`
	cursor: pointer;
	color: ${(props) => props.theme.colors.brand};
	font-weight: 500;
	font-size: ${(props) => props.theme.font.small};
	display: block;
	text-decoration: underline;
`;
